import React from 'react'
import { RouteObject } from 'react-router-dom'

import { PageId } from 'page-constants'

export type TRouteOverrides = Partial<Record<PageId, React.ReactElement>>

export const applyRouteOverrides = (
  overrides: TRouteOverrides = {},
  routes: RouteObject[],
): RouteObject[] => [
  ...routes.filter(({ path }) => !overrides[path as PageId]),
  ...Object.entries(overrides).map(([path, element]) => ({ path, element })),
]
